import { EMPLOYEE_REQUEST } from '../actions/utilities';

const INITIAL_STATE = {
    getEmployeeLoading: false,
    getEmployeeSuccess: false,
    getEmployeeFailure: false,
    getEmployeeError: null,
    employeeList: [],
    blockUserLoading: false,
    blockUserSuccess: false,
    blockUserFailure: false,
    blockUserError: null
}

export const employeeReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case EMPLOYEE_REQUEST.GET_EMPLOYEE_REQUEST:
            return {
                ...state,
                getEmployeeLoading: true,
                getEmployeeSuccess: false,
                getEmployeeFailure: false,
                getEmployeeError: null,
            }
        case EMPLOYEE_REQUEST.GET_EMPLOYEE_SUCCESS:
            return {
                ...state,
                getEmployeeLoading: false,
                getEmployeeSuccess: true,
                getEmployeeFailure: false,
                getEmployeeError: null,
                employeeList: action.payload
            }
        case EMPLOYEE_REQUEST.GET_EMPLOYEE_FAILURE:
            return {
                ...state,
                getEmployeeLoading: false,
                getEmployeeSuccess: false,
                getEmployeeFailure: true,
                getEmployeeError: action.payload,
            }
        case EMPLOYEE_REQUEST.BLOCK_UNBLOCK_EMPLOYEE_REQUEST:
            return {
                ...state,
                blockUserLoading: true,
                blockUserSuccess: false,
                blockUserFailure: false,
                blockUserError: null
            }
        case EMPLOYEE_REQUEST.BLOCK_UNBLOCK_EMPLOYEE_SUCCESS:
            let emp_list = state.employeeList;
            for (var i = 0; i < emp_list.length; i++) {
                if (emp_list[i].userId === action.payload.userId) {
                    emp_list[i] = action.payload
                }
            }
            return {
                ...state,
                blockUserLoading: true,
                blockUserSuccess: false,
                blockUserFailure: false,
                blockUserError: null,
                employeeList: emp_list
            }
        case EMPLOYEE_REQUEST.BLOCK_UNBLOCK_EMPLOYEE_FAILURE:
            return {
                ...state,
                blockUserLoading: true,
                blockUserSuccess: false,
                blockUserFailure: false,
                blockUserError: action.payload,
            }
        default:
            return state
    }
}